/*
  partner search
*/
/**
 * Desktop/Mobile Partner Search management
 */

/************************************************
		EVENT MANAGEMENT DESKTOP/MOBILE
    Creating search link dynamically
*************************************************/
$("form.partner-search").each(function() {

  //-- get form
  var _form = $(this);

  //-- on click/blur for its input, refresh form action property
  _form.on("click blur keyup", "input.search-query", function() {
    __SEARCH.updateAction(_form);
  });

  //-- on change for its radios, refresh action property
  _form.on("change", "input[name=search-option]", function() {
    __SEARCH.updateAction(_form);
  });

  //-- submit management
  _form.on("click", ".submit", function() {
    _form.submit();
  });
});

//-- submit management phase 2 (redirect users instead of actually submitting)
$("form.partner-search").on("submit", function(e) {
  e.preventDefault(e);
  window.location.href = $(this).attr("action");
});


//----- SEARCH FUNCTIONS
var __SEARCH = {
  /**
   * merchantOrProduct -  defines if the form must perform a search on merchant or product
   * @param {OBJECT} form_obj - the form checked
   * @return {OBJECT} which
   */
  merchantOrProduct: function(form_obj) {

    //-- init, default m
    var which = { short: "m", full: "merchant" };

    //-- get selected option
    var sel_option = form_obj.find("input[name=search-option]:checked");

    //-- if found one
    if (sel_option.length) {

      //-- get value
      var sel_option_value = sel_option.val();

      //-- set "which" value
      if (sel_option_value === "product") which = { short: "p", full: "product" };
    }

    //-- return
    return which;
  },


  /**
   * getKeywords - get keywords entered by the user inside the form
   * @param {OBJECT} form_obj - the form checked
   * @return {STRING} _input.val
   */
  getKeywords: function(form_bj) {
    var _input = form_bj.find("input.search-query");
    return _input.val();
  },


  /**
   * updateAction - update action property of a form
   * @param {OBJECT} form_obj - the form checked
   * @return {VOID}
   */
  updateAction: function(form_bj) {

    //-- get type of search
    var type = __SEARCH.merchantOrProduct(form_bj);

    //-- get keywords
    var keywords = __SEARCH.getKeywords(form_bj);

    //-- update form action property
    form_bj.attr("action", form_bj.attr("data-base-url")+type.short+"?type="+type.full+"&keywords="+keywords);
  },
};
